import React from 'react';
import { Accordion } from '@noths/polaris-client-ribbons-design-system';

import type { UIPublicAttribute } from 'src/adapters/storeToUI/adaptPublicAttributesToUI';
import * as styles from './PublicAttributes.styles';

interface PublicAttributesProps {
  publicAttributes: UIPublicAttribute[];
}

export const PublicAttributes = ({ publicAttributes }: PublicAttributesProps) => {
  if (publicAttributes.length === 0) {
    return null;
  }

  return (
    <Accordion id="publicAttributes" open={false} title={<h3>Product attributes</h3>}>
      <div css={styles.container}>
        {publicAttributes.map((attribute) => (
          <div css={styles.attributeItem} key={attribute.key}>
            <b>{attribute.title}:</b> {attribute.values.join(', ')}
          </div>
        ))}
      </div>
    </Accordion>
  );
};
